export default "__VITE_ASSET__5064f57d__"